module.exports = __webpack_public_path__ + "img/banner-wings.00b3a668.svg";